module.exports = __webpack_public_path__ + "static/media/saveIcon.a69fa570.svg";